export const model = {
  mainwarehouse_id: '',
  warehouse_id: '' ,
  product_id: '',
};